export const [
  SIGNUP_REQUEST,
  SIGNUP_ERROR,
  SIGNUP_SUCCESS,
  RESET_SIGNUP_STORE,
  SAVE_RELATIVES,
  SAVE_CUSTOMER,
  CHECK_EXISTING_REGISTERED_PHONE,
  SET_ALREADY_EXISTING_PHONE,
] = [
  "SIGNUP_REQUEST",
  "SIGNUP_ERROR",
  "SIGNUP_SUCCESS",
  "RESET_SIGNUP_STORE",
  "SAVE_RELATIVES",
  "SAVE_CUSTOMER",
  "CHECK_EXISTING_REGISTERED_PHONE",
  "SET_ALREADY_EXISTING_PHONE",
]
